// Two variants: zero-campaigns-in-store (the "onboarding" empty) and
// zero-results-for-filter ("clear filters").

import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Icon, SimpleButton, Typo, Flex } from '../../../../ui';

const Shell = styled.div`
  background: ${({ theme }) => theme.colors.NEU_0};
  border: 1px dashed ${({ theme }) => theme.colors.NEU_300};
  border-radius: 12px;
  padding: 56px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
`;

const CampaignsEmptyState = ({ variant = 'zero', onCreate, onClearFilters }) => {
  const { t } = useTranslation();

  if (variant === 'filtered') {
    return (
      <Shell>
        <Icon.Filter size='large' />
        <Typo.MediumText>
          {t('campaigns.empty.filtered', 'No campaigns match these filters.')}
        </Typo.MediumText>
        <SimpleButton variant='ghost' onClick={onClearFilters}>
          {t('campaigns.empty.clearFilters', 'Clear filters')}
        </SimpleButton>
      </Shell>
    );
  }

  return (
    <Shell>
      <Icon.Send size='large' />
      <Typo.ContentSmallHeader>
        {t('campaigns.empty.title', 'Reach your students with campaigns.')}
      </Typo.ContentSmallHeader>
      <Typo.SmallText color='textSecondary' style={{ maxWidth: 520 }}>
        {t(
          'campaigns.empty.description',
          'Send a newsletter, invite learners to a new course, or promote with a discount code.',
        )}
      </Typo.SmallText>
      <Flex gap='12' style={{ marginTop: 8 }}>
        <SimpleButton variant='primary' startIcon='Add' onClick={onCreate}>
          {t('campaigns.new', 'New campaign')}
        </SimpleButton>
      </Flex>
    </Shell>
  );
};

export default CampaignsEmptyState;
